import { light404Path } from '../lib/light-404';

export default defineNuxtPlugin(nuxt => {
  nuxt.hook('app:error', error => {
    if (Number((error as any)?.statusCode) !== 404 || !light404Path(window.location.pathname)) return;
    // Stop the previously hydrated application's polling and ad SDK on SPA errors.
    // The server checks the route/alias first and returns the non-hydrated HTML 404.
    window.location.replace(window.location.href);
  });
});
